export const FILTER = {
  UPCOMING: 'upcoming',
  HISTORY: 'history',
}
